import { render, staticRenderFns } from "./CancellationSummary.vue?vue&type=template&id=6c083e28&scoped=true&"
import script from "./CancellationSummary.vue?vue&type=script&lang=js&"
export * from "./CancellationSummary.vue?vue&type=script&lang=js&"
import style0 from "./CancellationSummary.vue?vue&type=style&index=0&id=6c083e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c083e28",
  null
  
)

export default component.exports